<div class="login-container">
  <div class="login-box">
    <h1 style="color: white;">Recuperación de correo electrónico</h1>
    <hr style="border-top: 2px solid rgba(255, 255, 255, 0.4);">
    <form name="loginForm">
      <div class="flex-container">
        <div class="option">
          <h2>Si desea que le reenvíen el correo electrónico de su último estudio, introduzca la dirección de correo que ha proporcionado a la clínica:</h2>
          <div class="input-group">
            <label for="mail">Correo electrónico:</label>
            <input type="text" id="mail" #Mail>
          </div>
        </div>
        <div style="display: flex;flex-direction: column;margin-top: 10px;width: 70%;">
          <button class="button" (click)="recoverEmail(Mail.value)">Reenviar</button>
        </div>

        <p style="color: white; margin-top: 10px;">Si tiene un localizador para acceder al estudio, <a
            class="text-golden underline" [routerLink]="['/acceso']">haga click aquí para acceder</a></p>

      </div>
    </form>
  </div>
</div>